/*
 * Slider controls for the social proof row.
 *
 * The row scrolls natively -- these buttons only drive that scroll, so
 * touch, trackpad and keyboard all keep working if the script never
 * runs. Controls stay hidden until the row is measured and found to
 * overflow, so a three-card row shows no arrows.
 */
(function () {
  'use strict';

  function setup(section) {
    var track = section.querySelector('[data-proof-track]');
    var nav = section.querySelector('[data-proof-nav]');
    if (!track || !nav) return;

    var prev = nav.querySelector('[data-proof-prev]');
    var next = nav.querySelector('[data-proof-next]');

    function step() {
      var card = track.querySelector('.pdp-proof__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function refresh() {
      // 2px of slack: sub-pixel widths otherwise leave the end button
      // permanently enabled with nothing left to scroll to.
      var max = track.scrollWidth - track.clientWidth;
      var overflows = max > 2;
      nav.hidden = !overflows;
      if (!overflows) return;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', refresh, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(refresh).observe(track);
    window.addEventListener('resize', refresh);
    refresh();
  }

  function init() {
    document.querySelectorAll('.pdp-proof').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // The theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', init);
})();
